module.exports = __webpack_public_path__ + "img/shouji.d83d2e94.png";